<!-- components/VendorDetails.vue -->

<template>
    <b-card title="Vendor Details">
      <!-- Vendor Name -->
      <b-form-group label="Vendor Name" label-for="vendor-name">
        <b-form-input
          id="vendor-name"
          v-model="vendorDetails.vendorName"
          :state="validateField('vendorName')"
          required
        ></b-form-input>
        <b-form-invalid-feedback>Vendor Name is required.</b-form-invalid-feedback>
      </b-form-group>
  
      <!-- Registered Address -->
      <b-form-group label="Registered Address" label-for="registered-address">
        <b-form-input
          id="registered-address"
          v-model="vendorDetails.registeredAddress"
          :state="validateField('registeredAddress')"
          required
        ></b-form-input>
        <b-form-invalid-feedback>Registered Address is required.</b-form-invalid-feedback>
      </b-form-group>
  
      <!-- Business Registration Documents -->
      <h5 class="mt-4">Business Registration Documents</h5>
  
      <!-- Certificate of Incorporation or Registration -->
      <b-form-group label="Certificate of Incorporation or Registration">
        <b-form-file
          v-model="vendorDetails.certificateOfIncorporation"
          accept=".pdf,.doc,.docx"
        ></b-form-file>
      </b-form-group>
  
      <!-- Memorandum and Articles of Association -->
      <b-form-group label="Memorandum and Articles of Association">
        <b-form-file
          v-model="vendorDetails.memorandumArticles"
          accept=".pdf,.doc,.docx"
        ></b-form-file>
      </b-form-group>
  
      <!-- Partnership Deed (if applicable) -->
      <b-form-group label="Partnership Deed (if applicable)">
        <b-form-file
          v-model="vendorDetails.partnershipDeed"
          accept=".pdf,.doc,.docx"
        ></b-form-file>
      </b-form-group>
  
      <!-- Trade License or Business Permit -->
      <b-form-group label="Trade License or Business Permit">
        <b-form-file
          v-model="vendorDetails.tradeLicense"
          accept=".pdf,.doc,.docx"
        ></b-form-file>
      </b-form-group>
  
      <!-- Proof of Address -->
      <h5 class="mt-4">Proof of Address</h5>
  
      <!-- Utility Bill -->
      <b-form-group label="Utility Bill (electricity, water, gas, etc.)">
        <b-form-file
          v-model="vendorDetails.utilityBill"
          accept=".pdf,.doc,.docx"
        ></b-form-file>
      </b-form-group>
  
      <!-- Lease Agreement or Rent Agreement -->
      <b-form-group label="Lease Agreement or Rent Agreement">
        <b-form-file
          v-model="vendorDetails.leaseAgreement"
          accept=".pdf,.doc,.docx"
        ></b-form-file>
      </b-form-group>
  
      <!-- Property Tax Receipt -->
      <b-form-group label="Property Tax Receipt">
        <b-form-file
          v-model="vendorDetails.propertyTaxReceipt"
          accept=".pdf,.doc,.docx"
        ></b-form-file>
      </b-form-group>
  
      <!-- Municipal License or Approval -->
      <b-form-group label="Municipal License or Approval">
        <b-form-file
          v-model="vendorDetails.municipalLicense"
          accept=".pdf,.doc,.docx"
        ></b-form-file>
      </b-form-group>
    </b-card>
  </template>
  
  <script>
  export default {
    name: 'VendorDetails',
    props: {
      value: Object,
      isSubmitted: Boolean,
    },
    data() {
      return {
        vendorDetails: this.value || {},
      };
    },
    methods: {
      validateField(fieldName) {
        if (!this.isSubmitted) return null;
        return this.vendorDetails[fieldName] ? true : false;
      },
    },
    watch: {
      vendorDetails: {
        handler(newValue) {
          this.$emit('input', newValue);
        },
        deep: true,
      },
    },
  };
  </script>
  